import { UsageCharts } from "@/app/billing/overview/components/usage-charts";
import { AccountDetailsCard } from "./components/account-details-card";
import { CurrentPlanCard } from "./components/current-plan-card";
import { ScheduledChangeAlert } from "./components/scheduled-change-alert";
import { UsageAllocationsSection } from "./components/usage-allocations-section";

function formatDate(dateString: string) {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export const BillingOverviewPage = () => (
  <div className="mx-auto space-y-8">
    <ScheduledChangeAlert />
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <CurrentPlanCard formatDate={formatDate} />
      <AccountDetailsCard formatDate={formatDate} />
    </div>
    <UsageCharts />
    <UsageAllocationsSection />
  </div>
);
